const prefix = 'lumahealth/ReferralOutboundPage';

export const CLEAR_REFERRAL_DATA = `${prefix}/CLEAR_REFERRAL_DATA`;

export const FORM_NAME = 'ReferralPageForm';

export const LOAD_APPOINTMENT_TYPES = `${prefix}/LOAD_APPOINTMENT_TYPES`;
export const LOAD_APPOINTMENT_TYPES_SUCCESS = `${prefix}/LOAD_APPOINTMENT_TYPES_SUCCESS`;
export const LOAD_APPOINTMENT_TYPES_ERROR = `${prefix}/LOAD_APPOINTMENT_TYPES_ERROR`;

export const LOAD_FACILITIES = `${prefix}/LOAD_FACILITIES`;
export const LOAD_FACILITIES_SUCCESS = `${prefix}/LOAD_FACILITIES_SUCCESS`;
export const LOAD_FACILITIES_ERROR = `${prefix}/LOAD_FACILITIES_ERROR`;

export const LOAD_ICD9_CODES = `${prefix}/LOAD_ICD9_CODES`;
export const LOAD_ICD9_CODES_SUCCESS = `${prefix}/LOAD_ICD9_CODES_SUCCESS`;
export const LOAD_ICD9_CODES_ERROR = `${prefix}/LOAD_ICD9_CODES_ERROR`;

export const LOAD_ICD10_CODES = `${prefix}/LOAD_ICD10_CODES`;
export const LOAD_ICD10_CODES_SUCCESS = `${prefix}/LOAD_ICD10_CODES_SUCCESS`;
export const LOAD_ICD10_CODES_ERROR = `${prefix}/LOAD_ICD10_CODES_ERROR`;

export const LOAD_PATIENTS = `${prefix}/LOAD_PATIENTS`;
export const LOAD_PATIENTS_SUCCESS = `${prefix}/LOAD_PATIENTS_SUCCESS`;
export const LOAD_PATIENTS_ERROR = `${prefix}/LOAD_PATIENTS_ERROR`;

export const LOAD_PROVIDERS = `${prefix}/LOAD_PROVIDERS`;
export const LOAD_PROVIDERS_SUCCESS = `${prefix}/LOAD_PROVIDERS_SUCCESS`;
export const LOAD_PROVIDERS_ERROR = `${prefix}/LOAD_PROVIDERS_ERROR`;

export const LOAD_REFERRAL = `${prefix}/LOAD_REFERRAL`;
export const LOAD_REFERRAL_SUCCESS = `${prefix}/LOAD_REFERRAL_SUCCESS`;
export const LOAD_REFERRAL_ERROR = `${prefix}/LOAD_REFERRAL_ERROR`;

export const LOAD_RENDERING_PROVIDERS = `${prefix}/LOAD_RENDERING_PROVIDERS`;
export const LOAD_RENDERING_PROVIDERS_ERROR = `${prefix}/LOAD_RENDERING_PROVIDERS_ERROR`;
export const LOAD_RENDERING_PROVIDERS_SUCCESS = `${prefix}/LOAD_RENDERING_PROVIDERS_SUCCESS`;

export const SAVE_REFERRAL = `${prefix}/SAVE_REFERRAL`;
export const SAVE_REFERRAL_SUCCESS = `${prefix}/SAVE_REFERRAL_SUCCESS`;
export const SAVE_REFERRAL_ERROR = `${prefix}/SAVE_REFERRAL_ERROR`;
